import React from 'react'

import { bool } from 'prop-types'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

// Subscriber-only header on a cacheable fast page. The SSR HTML -- which is what
// Googlebot and Lighthouse render -- omits it entirely, so it never adds to the
// measured DOM size, LCP, or CLS. It mounts client-side only once pageConfig
// reports a subscribed user. extractingCoreStyles (true only during the
// critical-CSS extraction pass) forces it visible so its styles are captured.
function UpgradeHeader({ extractingCoreStyles = false }) {
  const pageConfig = usePageConfig({ listener: 'full-page-config-loaded', checkIfAvailable: false })
  const isSubscribed = pageConfig?.threeDStudioAccessTier === 'subscribed'

  if (!isSubscribed && !extractingCoreStyles) {
    return null
  }

  return <span className="ai-sub-landing__placeholder">UpgradeHeader - coming soon</span>
}

UpgradeHeader.propTypes = {
  extractingCoreStyles: bool,
}

export default UpgradeHeader
